import React from 'react';

import { Router } from './routes';

const App: React.FC = () => {
    return <Router />;
};

export default App;
